import React, { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { InlinePlayer } from '@dboxdev/ui-components'
import { useScrollSmoother } from '@dboxdev/ui-components/gsap'
import {
  Overlay,
  VideoBox,
  CloseButton,
  FADE_DURATION
} from './index.styled'

const FilmPopup = ({ video, title, onClose }) => {
  const smoother = useScrollSmoother()
  const [closing, setClosing] = useState(false)
  const closeTimeout = useRef(null)
  const onCloseRef = useRef(onClose)

  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])

  const startClose = useCallback(() => {
    if (closeTimeout.current) return
    setClosing(true)
    closeTimeout.current = setTimeout(() => onCloseRef.current(), FADE_DURATION)
  }, [])

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') startClose()
    }

    const instance = smoother?.current
    instance?.paused(true)
    document.addEventListener('keydown', onKeyDown)

    return () => {
      instance?.paused(false)
      document.removeEventListener('keydown', onKeyDown)
      clearTimeout(closeTimeout.current)
    }
  }, [startClose, smoother])

  return createPortal(
    <Overlay $isClosing={closing} role='dialog' aria-modal='true' aria-label={title}>
      <VideoBox>
        <InlinePlayer
          video={video}
          controls
          autoPlay
          loop={false}
          muted={false}
        />
      </VideoBox>
      <CloseButton type='button' onClick={startClose} aria-label='Close the film'>
        <svg viewBox='0 0 41.4142 41.4142' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <line x1='0.707107' y1='0.707107' x2='40.7071' y2='40.7071' stroke='currentColor' strokeWidth='2' />
          <line x1='40.7071' y1='0.707107' x2='0.707107' y2='40.7071' stroke='currentColor' strokeWidth='2' />
        </svg>
      </CloseButton>
    </Overlay>,
    document.body
  )
}

export default FilmPopup
